import type { NativeBridge } from "./bridge";
import { webBridge } from "./impl.web";
let bridge: NativeBridge = webBridge;
export function installNativeBridge(next: NativeBridge): void { bridge = next; }
export function nativeBridge(): NativeBridge { return bridge; }
